// Owner: library. Titles of the Library's keyboard commands. `commands.ts` loads with the app shell, but
// the Library's messages load with its screens (a deferred catalog, plan §12), so the screen fills
// these titles in when it mounts (`setLibraryCommandTitles`), before its list scope is active and the
// commands can show in the `?` sheet or ⌘K. No message keys here.
export const LIBRARY_COMMAND_IDS = [
  'scope',
  'next',
  'previous',
  'down',
  'up',
  'select',
  'selectAll',
  'rename',
  'move',
  'trash',
] as const;
export type LibraryCommandId = (typeof LIBRARY_COMMAND_IDS)[number];

const titles = new Map<LibraryCommandId, string>();

export function setLibraryCommandTitles(next: Record<LibraryCommandId, string>): void {
  for (const id of LIBRARY_COMMAND_IDS) titles.set(id, next[id]);
}

export const libraryCommandTitle = (id: LibraryCommandId): string => titles.get(id) ?? id;
